import React, {Fragment, useEffect, useState} from 'react'
import {Container, Row, Col, FormFeedback} from "reactstrap"
import _ from "lodash"
import {useForm} from "react-hook-form"
import classnames from "classnames"
import {useSelector} from 'react-redux'
//************************************//
import {trans} from "@utils"
import CustomFormGroup from "@src/components/helpers/CustomFormGroup"
import InputContainer from "@src/components/helpers/InputContainer"
import {_getAllStructures, _getStructureData} from "@cmodules/resources"
//************************************//
import LoadingIndicator from "@src/components/LoadingIndicator"
import {_getAllAssetTypes, _showAssetType} from "../redux/actions"
//************************************//
const FormGroup = ({children}) => {
  return (
    <CustomFormGroup title={trans('asset.inputs.field')}>
      {children}
    </CustomFormGroup>
  )
}
//************************************//

const AssetTypeFieldsSelect = props => {
//************************************//
  const {useForm, name = "", assetTypeUuid = null, defaultValue = null, rules = {}, hideFormGroup = false, isDisabled} = props
  const {control, errors, watch, register, getValues, setValue } = useForm
//************************************//
  const assetTypes = useSelector(store => store.asset.data.asset_types)
//************************************//
  const staticOptions = [
    {label: trans('asset.inputs.assetId'), value: "asset_id", field_type: "text"},
    {label: trans('asset.inputs.displayName'), value: "display_name", field_type: "text"}
  ]
//************************************//
  const [assetType, setAssetType] = useState({fields: []})
  const [loading, setLoading] = useState(false)
  const [assetTypeFieldOptions, setAssetTypeFieldOptions] = useState(staticOptions)
//************************************//
  const setFieldValue = (val, items) => {
    if (val && _.find(items, x => x.value === val)) {
      setValue(name, _.find(items, x => x.value === val))
    } else {
      setValue(name, '')
    }
  }
//************************************//
  const getData = (change_count) => {
    if (assetTypeUuid) {
      // setLoading(true)
      const data = _.find(assetTypes, assetType => assetType.uuid === assetTypeUuid)
      setAssetType(data)
      const newAssetTypeFieldOptions = [
        ...staticOptions,
        ..._.map(data?.fields, x => ({...x, label: x.name, value: x.key}))
      ]
      setAssetTypeFieldOptions(newAssetTypeFieldOptions)
      // setLoading(false)
      if (change_count > 0) {
        setFieldValue(_.get(getValues(name), 'value'), newAssetTypeFieldOptions)
        setValue('error_field_not_valid', false)
      }  else {
        setFieldValue(defaultValue, newAssetTypeFieldOptions)
        if (defaultValue && !getValues(name)) {
          register('error_field_not_valid')
          setValue('error_field_not_valid', true)
        }
      }
    }
  }
//************************************//
  useEffect(() => {
    if (!getValues('change_count') && !_.isNumber(getValues('change_count'))) {
      register('change_count')
      setValue('change_count', defaultValue ? 0 : 1)
      if (defaultValue === 'asset_id' || defaultValue === 'display_name') {
        setValue(name, _.find(staticOptions, x => x.value === defaultValue))
      }
    } else {
      if (getValues('change_count') >= 0) {
        getData(getValues('change_count'))
      }
      setValue('change_count', getValues('change_count')  + 1)
    }
  }, [assetTypeUuid])
//************************************//
  const InputWrapper = hideFormGroup ? Fragment : FormGroup
//************************************//
  return (
    <InputWrapper>
      <InputContainer
        isLoading={loading}
        isDisabled={loading || isDisabled}
        control={control}
        type='select'
        options={assetTypeFieldOptions}
        name={name}
        defaultValue={''}
        className={classnames('react-select', {'is-invalid':_.get(errors, name)})}
        rules={rules}
      />
      {_.get(errors, name) && <FormFeedback>{_.get(errors, `${name}.message`)}</FormFeedback>}
      <span className={'small text-danger'}>{(!getValues(name) && getValues('error_field_not_valid')) && "Error in field"}</span>
    </InputWrapper>
  )
}

AssetTypeFieldsSelect.propTypes = {

}

export default AssetTypeFieldsSelect
